<div >
  <router-outlet #o="outlet"></router-outlet>
</div>
<ngx-loading-bar [color]="'var(--primary)'"></ngx-loading-bar>
